/*************************************************/
/* TABS COMPONENT                                */
/*************************************************/

export function tabs() {
    const tabComponents = document.querySelectorAll('.tabs-component');

    tabComponents.forEach(componentRoot => {
        initInstance(componentRoot);
    });
}

function initInstance(componentRoot) {
    const navItems = componentRoot.querySelectorAll('.tabs-component__nav-item button');

    navItems.forEach((item, index) => {
        item.addEventListener('click', () => handleAccordionItemClick(item, index, componentRoot));
    });
}

const handleAccordionItemClick = (clickedButton, index, componentRoot) => {
    const container = componentRoot.querySelector('.tabs-component__container');
    const allAccordionItems = container ? container.querySelectorAll('.accordion__item') : [];

    allAccordionItems.forEach((accordionItem) => {
        accordionItem.classList.remove('accordion__item--active');
    });

    const allButtons = componentRoot.querySelectorAll('.tabs-component__nav-item button');
    allButtons.forEach((button) => {
        button.classList.remove('active-title');
    });

    const clickedAccordionItem = componentRoot.querySelector(
        `.tabs-component__container .accordion__item[data-accordion-item-index="${index}"]`
    );

    if (clickedAccordionItem) {
        clickedAccordionItem.classList.add('accordion__item--active');
        clickedButton.classList.add('active-title');
    }
}